module.exports = __webpack_public_path__ + "static/media/image_clip_wave.9f37e548.svg";